enum MobileOs {
  Windows = 'windows',
  Android = 'android',
  IOS = 'ios',
}

export default MobileOs;
